import { toApiDob } from 'lib/date';

export const formValuesToAPI = (formValues) => {
    const getFormattedZipCode = () => {
        const zipCode = formValues.zipCode;

        if (formValues?.country === 'United States of America' && zipCode?.includes('-'))
            return zipCode.split('-')[0];

        return zipCode;
    };

    return {
        firstName: formValues.firstName,
        middleName: formValues.middleName,
        lastName: formValues.lastName,
        dob: toApiDob(formValues.dob),
        houseNumber: formValues.houseNumber || null,
        streetName: formValues.streetName || null,
        apartmentNumber: formValues.apartmentNumber || null,
        address:
            formValues.address ||
            [formValues.houseNumber, formValues.streetName].filter(Boolean).join(', ') ||
            null,
        city: formValues.city || null,
        zipCode: getFormattedZipCode(),
        state: formValues.state || null,
        country: formValues.country || null,
        ssn: formValues.ssn, // BELOW 2 options to be removed once workflows are setup.
        customVerificationOptions: formValues.customVerificationOptions,
        token: formValues.customVerificationOptions ? formValues.token : null,
        email: formValues.email,
        phone: formValues.phone,
    };
};
